export const cardTemplates = [
  {
    id: "COMMUNITY",
    title: "COMMUNITY",
    totalKey: "communityTotal",
    suffix: "Recorded",
    className: "bg-blue-100"
  },
  {
    id: "ZONE",
    title: "ZONES",
    totalKey: "zoneTotal",
    descKey: "zoneVariance",
    suffix: "Recorded",
    className: "bg-violet-100"
  },
  {
    id: "BLOCK",
    title: "BLOCKS",
    totalKey: "blockTotal",
    descKey: "blockVariance",
    suffix: "Recorded",
    className: "bg-violet-100"
  },
  {
    id: "PROPERTY",
    title: "PROPERTY",
    totalKey: "propertyTotal",
    descKey: "propertyVariance",
    suffix: "Recorded",
    className: "bg-green-100"
  },
];

export const MONTH_RANGE = "monthRange";
export const PERIOD_FROM = "periodFrom";
export const PERIOD_TO = "periodTo";
export const GL_MASTER_ID = "glMasterIds";
export const DISTRIBUTION_LEVEL = "distributionLevel";

export const categoriesMapping = {
  E: "Expense",
  I: "Income",
  A: "Assets",
  L: "Liability"
} as const

export const levelOrder = ["COMMUNITY", "ZONE", "BLOCK", "PROPERTY"];